export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7315.5573cd39.jpg";